import React, { useState } from 'react'
import {
    AllOnBoardSchedule,
    ConsoleFilterOptionType,
    ContactStation,
    CustomScheduleModalDataType,
    GroundStation,
    LaunchDetails,
    LoaderTypes,
    Modals,
    OnboardScheduleDetailsType,
    Orbit,
    OrbitParams,
    RemoteComponentsType,
    RemoteConnectionStatusType,
    ScenarioResponseType,
    ScheduleConfirmationModalType,
    ScheduleTask,
    SelectedContact,
    SelectedSatelliteType,
    SelectedScheduleTask,
    SimulationTime,
    TaskPlanDetails,
    ScenarioDeploymentDetails,
} from '../types';
import { CommandCenterStateProviderContext } from '../context';
import * as Cesium from "cesium";
import { PopoverProvider } from '../../CommonComponents/popover/PopoverProvider';
import { SecurityConfigDetailsType, SecurityConfigFormData } from '../../CommonComponents/security-configuration/types';
import { TelemetryDashboardConfigType, TelemetryPanel, TelemetryConfirmState, TelemetryStatusType, MenuState, UnitSystem } from '../components/center/telemetry/lib/dashboard-types';
import { TelemetrySeries } from '../components/center/telemetry/lib/telemetry-types';
import { DEFAULT_UNITS, TelemetryLayoutMode, TelemetryViewportState } from '../../CommonComponents/telemetry';



interface CommandCenterStateProviderProps {
    children: React.ReactNode;
}

const CommandCenterStateProvider: React.FC<CommandCenterStateProviderProps> = ({ children }) => {
    const EncripTionOptions = [
        { value: 'security_key_0', label: 'Security Key 0', prevIndex: 2, nextIndex: 1, id: 0 },
        { value: 'security_key_1', label: 'Security Key 1', prevIndex: 0, nextIndex: 2, id: 1 },
        { value: 'security_key_2', label: 'Security Key 2', prevIndex: 1, nextIndex: 0, id: 2 },
    ]
    //////////// ERROR PROVIDER STATES ///////////////
    const [error, setError] = useState<{
        header: string;
        message: string;
    } | null>(null);


    //////////// LOADER PROVIDER STATES ///////////////
    const [commandCenterLoader, setCommandCenterLoader] = useState<LoaderTypes>({
        orbit: true,
        group: true,
        viewer: true,
        timeline: true,
        scenario: true,
        contacts: true,
        schedule: true,
        telemetry: true,
        undeploy: false,
    });


    //////////// OVERLAY PROVIDER STATES ///////////////
    const [overlayData, setOverlayData] = useState<{
        overlay: string;
        data: any;
        position: { x: number, y: number };
    } | null>(null);


    //////////// MODALS PROVIDER STATES ///////////////
    const [modals, set_Modals] = useState<Modals[] | []>([])


    //////////// SOCKET PROVIDER STATES ///////////////
    const [socket, setSocket] = useState<WebSocket | null>(null)


    //////////// ORBIT PROVIDER STATES ///////////////
    const [orbitParams, setOrbitParams] = useState<OrbitParams>({} as OrbitParams);
    const [launchDetails, setLaunchDetails] = useState<LaunchDetails[]>([]);
    const [orbitData, setOrbitData] = useState<Orbit | null>(null)


    //////////// VIEWER PROVIDER STATES ///////////////
    const [viewer, set_viewer] = useState<Cesium.Viewer | null>(null);
    const [multiplier, set_multiplier] = useState<number>(1);
    const [viewer_state, set_viewer_state] = useState<'play' | 'pause'>('play');
    const [current_simulation_time, set_current_simulation_time] = useState<number>(0);


    //////////// SCENARIO PROVIDER STATES ///////////////
    const [scenario, set_scenario] = useState<ScenarioResponseType | null>(null);
    const [deploymentSessionType, setDeploymentSessionType] = useState<string | null>(null);
    const [satellites, set_satellites] = useState<SelectedSatelliteType[] | null>(null);
    const [selected_satellite, set_selected_satellite] = useState<SelectedSatelliteType | null>(null);
    const [unDeployLoader, setUnDeployLoader] = useState<boolean | {}>(false);
    const [simulation_time, set_simulation_time] = useState<SimulationTime>({
        start_time: 0,
        end_time: 0,
        duration: 0,
        manual_change: false,
    })
    const [grpGrafanaData, setGrpGrafanaData] = useState<any[]>([])
    const [grafana, set_grafana] = useState<any[]>([])
    const [telemetry_time, set_telemetry_time] = useState<[Date | null, Date | null] | null>(null);
    const [selected_satellite_group, set_selected_satellite_group] = useState<any>(null)
    const [satellite_groups, set_satellite_groups] = useState<any>(null)


    //////////// HWIL | QUICK_DEPLOY STATES ///////////////
    const [remoteAppLoader, setRemoteAppLoader] = useState<boolean>(false)
    const [allRemoteApplications, setAllRemoteApplications] = useState<RemoteComponentsType>({
        edges: [],
        nodes: []
    })
    const [remoteConnectionStatus, setRemoteConnectionStatus] = useState<RemoteConnectionStatusType[]>([])
    const [remoteConnectionModal, setRemoteConnectionModal] = useState<boolean>(false)

    //////////// CONTACTS PROVIDER STATES ///////////////
    const [all_ground_stations, set_all_ground_stations] = useState<GroundStation[]>([])
    const [selectedScheduleTask, setSelectedScheduleTask] = useState<SelectedScheduleTask>({
        default_schedule: true,
        schedule_data: {} as ScheduleTask,
    })
    const [selectedSchedule, setSelectedSchedule] = useState<null | any>(null)
    const [selectedContact, setSelectedContact] = useState<SelectedContact>(null)
    const [contacts, setContacts] = useState<{
        previous_contacts: null | ContactStation[],
        ongoing_contacts: null | ContactStation[],
        upcoming_contacts: null | ContactStation[]
        current_time: null | number,
    }>({
        previous_contacts: null,
        ongoing_contacts: null,
        upcoming_contacts: null,
        current_time: null,
    })
    const [configured_gs, set_configured_gs] = useState<GroundStation[]>([])
    const [timelineContactData, setTimelineContactData] = useState<ContactStation[]>([])
    const [planingContactData, setPlaningContactData] = useState<ContactStation[]>([])
    const [allOnBoardSchedule, setAllOnBoardSchedule] = useState<AllOnBoardSchedule>({} as AllOnBoardSchedule)
    const [scheduleData, setScheduleData] = useState<ScheduleTask[]>([])
    const [timelineScheduleData, setTimelineScheduleData] = useState<ScheduleTask[]>([])
    const [scheduleDetails, setScheduleDetails] = useState<{
        start_time: number,
        name: string,
    }>({
        start_time: 0,
        name: '',
    })

    const [supportedSystemFaults, setSupportedSystemFaults] = useState({})
    const [injectedFaultList, setInjectedFaultList] = useState([])
    //////////CONSOLE RELATED STATES /////////////
    const [consoleFilterOptions, setConsoleFilterOptions] = useState<any>(null)
    const [consoleFilterGroups, setConsoleFilterGroups] = useState<Map<string, ConsoleFilterOptionType>>(new Map());
    const [originalFilterMetadata, setOriginalFilterMetadata] = useState<any>(null);
    const [referenceIdConsole, setReferenceIdConsole] = useState<string | null>(null);
    const [highlightedCommands, setHighlightedCommands] = useState<Set<string>>(new Set());

    //File Transfer states --> GROUND FILES
    const [allACPStorageFiles, setAllACPStorageFiles] = useState<Record<string, Map<string, any>> | null>(null);
    const [progessOfSatUpload, setProgressOfSatUpload] = useState<Map<string, number> | null>(null)
    const [allDestinationIds, setAllDestinationIds] = useState<any[] | null>(null)
    const [isGroundFilesLoading, setIsGroundFilesLoading,] = useState<boolean>(false)

    //File transfer states --> Onboard files
    // Change state to accept grouped payloads
    const [allOnboardFiles, setAllOnboardFiles] = useState<Record<string, Map<string, any>> | null>(null);
    const [allDownlinkingFiles, setAllDownlinkingFiles] = useState<Map<string, any> | null>(null);
    const [isDownlinkqueueLoading, setIsDownlinkqueueLoading,] = useState<boolean>(false)
    const [downlinkHistoryFiles, setDownlinkHistoryFiles] = useState<Map<string, any> | null>(null);
    const [isOnboardFilesLoading, setIsOnboardFilesLoading] = useState(false);
    const [downlinkRefreshTime, setDownlinkRefreshTime] = useState<number | null>(null);
    const [isRefreshTimeLoading, setIsRefreshTimeLoading] = useState<boolean>(false);



    // CUSTOM SCHEDULE STATES
    const [onboardScheduleDetails, setOnboardScheduleDetails] = useState<OnboardScheduleDetailsType>({
        scheduleData: {
            executed: [],
            planned: [],
            active: [],
            available: [],
        },
        selectedSchedule: null,
        selectedTask: null,
        selectedTelecommand: null,
    })
    const [customScheduleModalData, setCustomScheduleModalData] = useState<CustomScheduleModalDataType>(null)
    const [taskPlanDetails, setTaskPlanDetails] = useState<TaskPlanDetails>({
        allTaskPlans: [],
        allAdhocTasks: []
    })
    const [scheduleConfirmationModal, setScheduleConfirmationModal] = useState<ScheduleConfirmationModalType>(null)

    const [securityConfig, setSecurityConfig] = useState<SecurityConfigDetailsType | null>(null)
    const [securityConfigFormData, setSecurityConfigFormData] = useState<SecurityConfigFormData>({
        taskType: null,
        keyType: null,
        keyValue: '',
        keyExchangeType: 'key',
        activationFlag: null,
        loading: false,
        encriptionEnabled: true,
        encriptionKey: EncripTionOptions[0],
    })

    ////////// TELEMETRY STATES /////////////
    const [telemetryDashboards, setTelemetryDashboards] = useState<TelemetryDashboardConfigType | null>(null);
    const [activeTelemetryDashboardId, setActiveTelemetryDashboardId] = useState<string>("db-overview");
    const [expandedTelemetryPanel, setExpandedTelemetryPanel] = useState<TelemetryPanel | null>(null);
    const [configPanel, setConfigPanel] = useState<TelemetryPanel | null>(null);
    const [addModalOpen, setAddModalOpen] = useState<boolean>(false);
    const [insertGap, setInsertGap] = useState<any>(null);
    const [openTelemetryDropdownId, setOpenTelemetryDropdownId] = useState<string | null>(null);
    const [selectedTelemetryPanelId, setSelectedTelemetryPanelId] = useState<string | null>(null);
    const [telemetryConfirmState, setTelemetryConfirmState] = useState<TelemetryConfirmState | null>(null);
    const [telemetryMenuState, setTelemetryMenuState] = useState<MenuState | null>(null);
    const [telemetrySettingsOpen, setTelemetrySettingsOpen] = useState<boolean>(false);
    const [telemetryPrecision, setTelemetryPrecision] = useState<number>(2);
    const [telemetryUnits, setTelemetryUnits] = useState<UnitSystem>({ ...DEFAULT_UNITS } as UnitSystem);
    const [telemetryTimeframe, setTelemetryTimeframe] = useState<number>(60);
    const [telemetryCustomStartTime, setTelemetryCustomStartTime] = useState<number | null>(null);
    const [telemetryLayoutMode, setTelemetryLayoutMode] = useState<TelemetryLayoutMode>('grid');
    const [telemetrySeries, setTelemetrySeries] = useState<TelemetrySeries[]>([]);
    const [telemetryStatus, setTelemetryStatus] = useState<TelemetryStatusType>('loading');
    const [isTelemetryListening, setIsTelemetryListening] = useState<boolean>(true);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState<boolean>(false);
    const [isTelemetryDataLoading, setIsTelemetryDataLoading] = useState<boolean>(true);
    const [scenarioDeploymentDetails, setScenarioDeploymentDetails] = useState<ScenarioDeploymentDetails | null>(null);
    const [savedTelemetryDashboards, setSavedTelemetryDashboards] = useState<TelemetryDashboardConfigType | null>(null);
    const [isSavingTelemetryWorkspace, setIsSavingTelemetryWorkspace] = useState<boolean>(false);
    const [telemetryViewport, setTelemetryViewport] = useState<TelemetryViewportState>({
        spanMs: 60 * 60000,
        offsetMs: 0,
    });

    return (
        <CommandCenterStateProviderContext.Provider
            value={{
                error,
                setError,

                commandCenterLoader,
                setCommandCenterLoader,

                socket,
                setSocket,

                scenario,
                set_scenario,
                deploymentSessionType,
                setDeploymentSessionType,
                satellites,
                set_satellites,
                selected_satellite,
                set_selected_satellite,
                unDeployLoader,
                setUnDeployLoader,
                simulation_time,
                set_simulation_time,
                grpGrafanaData,
                setGrpGrafanaData,
                grafana,
                set_grafana,
                telemetry_time,
                set_telemetry_time,
                selected_satellite_group,
                set_selected_satellite_group,
                satellite_groups,
                set_satellite_groups,

                remoteAppLoader,
                setRemoteAppLoader,
                allRemoteApplications,
                setAllRemoteApplications,
                remoteConnectionStatus,
                setRemoteConnectionStatus,
                remoteConnectionModal,
                setRemoteConnectionModal,

                viewer,
                set_viewer,
                multiplier,
                set_multiplier,
                viewer_state,
                set_viewer_state,
                current_simulation_time,
                set_current_simulation_time,

                all_ground_stations,
                set_all_ground_stations,
                selectedScheduleTask,
                setSelectedScheduleTask,
                selectedSchedule,
                setSelectedSchedule,
                selectedContact,
                setSelectedContact,
                contacts,
                setContacts,
                configured_gs,
                set_configured_gs,
                timelineContactData,
                setTimelineContactData,
                planingContactData,
                setPlaningContactData,
                allOnBoardSchedule,
                setAllOnBoardSchedule,
                scheduleData,
                setScheduleData,
                timelineScheduleData,
                setTimelineScheduleData,
                scheduleDetails,
                setScheduleDetails,

                orbitParams,
                setOrbitParams,
                launchDetails,
                setLaunchDetails,
                orbitData,
                setOrbitData,

                modals,
                set_Modals,

                overlayData,
                setOverlayData,

                supportedSystemFaults,
                setSupportedSystemFaults,
                injectedFaultList,
                setInjectedFaultList,

                //CONSOLE RELATED STATES//
                consoleFilterOptions,
                setConsoleFilterOptions,
                consoleFilterGroups,
                setConsoleFilterGroups,
                originalFilterMetadata,
                setOriginalFilterMetadata,
                referenceIdConsole,
                setReferenceIdConsole,
                highlightedCommands,
                setHighlightedCommands,
                //FILE TRANSFER STATES// --> GROUND FILES
                allACPStorageFiles,
                setAllACPStorageFiles,
                progessOfSatUpload,
                setProgressOfSatUpload,
                allDestinationIds,
                setAllDestinationIds,
                isGroundFilesLoading,
                setIsGroundFilesLoading,
                //FILE TRANSFER STATES// --> ONBOARD FILES
                allOnboardFiles,
                setAllOnboardFiles,
                allDownlinkingFiles,
                setAllDownlinkingFiles,
                isDownlinkqueueLoading,
                setIsDownlinkqueueLoading,
                downlinkHistoryFiles,
                setDownlinkHistoryFiles,
                isOnboardFilesLoading,
                setIsOnboardFilesLoading,
                downlinkRefreshTime,
                setDownlinkRefreshTime,
                isRefreshTimeLoading,
                setIsRefreshTimeLoading,

                //CUSTOM SCHEDULE STATES
                onboardScheduleDetails,
                setOnboardScheduleDetails,
                customScheduleModalData,
                setCustomScheduleModalData,

                taskPlanDetails,
                setTaskPlanDetails,

                scheduleConfirmationModal,
                setScheduleConfirmationModal,

                //SECURITY CONFIG STATES
                securityConfig,
                EncripTionOptions,
                setSecurityConfig,
                securityConfigFormData,
                setSecurityConfigFormData,

                //TELEMETRY STATES
                telemetryDashboards,
                setTelemetryDashboards,
                activeTelemetryDashboardId,
                setActiveTelemetryDashboardId,
                expandedTelemetryPanel,
                setExpandedTelemetryPanel,
                openTelemetryDropdownId,
                setOpenTelemetryDropdownId,
                selectedTelemetryPanelId,
                setSelectedTelemetryPanelId,
                telemetryConfirmState,
                setTelemetryConfirmState,
                telemetryMenuState,
                setTelemetryMenuState,
                telemetrySettingsOpen,
                setTelemetrySettingsOpen,
                telemetryPrecision,
                setTelemetryPrecision,
                telemetryUnits,
                setTelemetryUnits,
                telemetryTimeframe,
                setTelemetryTimeframe,
                telemetryCustomStartTime,
                setTelemetryCustomStartTime,
                telemetryLayoutMode,
                setTelemetryLayoutMode,
                telemetrySeries,
                setTelemetrySeries,
                telemetryStatus,
                setTelemetryStatus,
                isTelemetryListening,
                setIsTelemetryListening,
                hasUnsavedChanges,
                setHasUnsavedChanges,
                isTelemetryDataLoading,
                setIsTelemetryDataLoading,
                scenarioDeploymentDetails,
                setScenarioDeploymentDetails,
                configPanel,
                setConfigPanel,
                insertGap,
                setInsertGap,
                addModalOpen,
                setAddModalOpen,
                telemetryViewport,
                setTelemetryViewport,
                savedTelemetryDashboards,
                setSavedTelemetryDashboards,
                isSavingTelemetryWorkspace,
                setIsSavingTelemetryWorkspace,
            }}
        >
            <PopoverProvider>
                {children}
            </PopoverProvider>
        </CommandCenterStateProviderContext.Provider>
    )
}

export default CommandCenterStateProvider
